<template>

    <div class="page">

        <div class="header">
            <div class="back" @click="goStats">
                <img src="/img/stats/arrow-left-blue.svg" class="img__24 mr__4">
                <span class="text-lSemibold color__aquamarine" v-show="isDesktop">{{$t('global_back')}}</span>
            </div>
            <span
                :class="{'text-lSemibold': !isDesktop, 'title-baseSemibold': isDesktop}">{{ $t('referral_page_title') }}</span>
        </div>

        <div class="container">

            <article class="sponsorship">

                <div class="green-bloc">
                    <div class="left">
                        <p class="text-lMedium color__white">{{ $t('statistics_refer_friends') }}</p>

                        <button class="cta-small-tertiary cta-content mt__16" @click="openShareStatsImage">
                            <span class="mr__8">{{ $t('menu_share') }}</span>
                            <img src="/img/stats/share-blue.svg" class="img__20">
                        </button>
                    </div>
                    <div>
                        <img src="/img/stats/sponsorship-users.svg" class="users">
                    </div>
                </div>

                <div class="white-bloc middle-bloc" @click="copyCode">
                    <div class="code-generating" v-if="codeGenerating">
                        <span
                            class="text-baseSemibold color__moon">{{ $t('statistics_referral_sponsor_generating') }}</span>
                        <lottie-loader :size="32"></lottie-loader>
                    </div>
                    <template v-else>
                        <img :src="copyBlocImage" class="img__20 copy-img">
                        <span class="text-sSemibold color__moon"
                              :class="{'color__forest': codeCopied}">{{ copyBlocText }}</span>
                        <span class="title-baseSemibold">{{ user.partnerCode }}</span>
                    </template>
                </div>

                <div class="white-bloc">
                    <p class="text-xlSemibold sponsor">{{ $t('Referral_subtitle') }}</p>
                    <lottie-loader :size="32" v-if="codeGenerating"></lottie-loader>
                    <template v-else>
                        <markdown v-show="isGodFather" class="mt__8 text-lRegular" :color="'#5EA774'"
                                  :text="$tc('referral_nb_referred', 0, {nb_sponsored: referrals.referrals.length, trees: referrals.referrals.length})"></markdown>
                        <span class="text-lRegular color__stone mt__8"
                              v-show="!isGodFather">{{ $t('referral_not_sponsored') }}</span>
                    </template>

                    <img src="/img/stats/sponsorship-forest.svg" class="forest">

                    <div class="grey-bloc" v-if="isGodFather">
                        <div v-for="(referral, index) in referrals.referrals" class="referral"
                             :class="{'mt__16': index !== 0}">
                            <span class="text-lMedium">{{ referral.name }}</span>
                            <span
                                class="text-baseRegular color__moon">{{ $tc('we_forest_reffered_on_date', 0, {date: dateFormat(referral.date)}) }}</span>
                        </div>
                    </div>
                </div>
            </article>
        </div>
        <share-stats-image ref="SSI"></share-stats-image>
    </div>


</template>

<script>

import Vuex from 'vuex'

import I18n from '../modules/i18n'
import Tag from '../modules/tag'

import LottieLoader from '../components/lottie/LottieLoader'
import Markdown from '../components/Markdown'
import ShareStatsImage from '../components/ShareStatsImage'

export default {

    name: 'sponsorship',

    components: {
        LottieLoader,
        Markdown,
        ShareStatsImage
    },

    computed: {
        ...Vuex.mapGetters([
            'user',
            'referrals'
        ]),

        copyBlocImage() {
            return this.codeCopied ? '/img/stats/check-circle-green.svg' : '/img/stats/copy-grey.svg'
        },

        copyBlocText() {
            return this.codeCopied ? this.$t('we_forest_code_copied') : this.$t('we_forest_code')
        },

        codeGenerating() {
            return !this.user.partnerCode
        },

        isGodFather() {
            return this.referrals.referrals.length > 0
        }
    },

    data() {
        return {
            codeCopied: false
        }
    },

    mounted() {
        this.getReferralsAsync()
        this.getUserAsync()
        Tag.pageViewGA(this, 'referral')
    },

    methods: {

        ...Vuex.mapActions([
            'getUserAsync',
            'getReferralsAsync'
        ]),

        copyCode() {
            if (this.user.partnerCode) {
                const element = document.createElement('textarea')
                element.value = this.user.partnerCode
                document.body.appendChild(element)
                element.select()
                document.execCommand('copy')
                document.body.removeChild(element)
                this.codeCopied = true

                Tag.clickAmplitude(this, 'copie_code_referral', null, 'referral')
            }
        },

        dateFormat(date) {
            return new Date(date).toLocaleDateString(I18n.get(this))
        },

        goStats() {
            Tag.clickAmplitude(this, 'back', null, 'referral')
            this.$router.push({path: '/stats'})
        },

        openShareStatsImage() {
            Tag.clickAmplitude(this, 'share_referral', null, 'referral')
            this.$refs.SSI.open()
        }
    }
}
</script>

<style lang="scss" scoped>

.page {
    background-color: $timberwolf;
    display: flex;
    flex-direction: column;


    .header {
        position: relative;
        display: flex;
        flex-direction: row;
        padding: 16px 20px;
        align-items: center;
        justify-content: center;
        text-align: start;
        box-shadow: 0px 1px 0px 0px #D5D7DA;
        min-height: 56px;
        @media screen and (min-width: $above-tablet-length) {
            background-color: $white;
            padding: 22px;
        }

        .back {
            display: flex;
            flex-direction: row;
            align-items: center;
            position: absolute;
            left: 20px;
            cursor: pointer;
            @media screen and (min-width: $above-tablet-length) {
                left: 32px;
            }
        }
    }

    .container {
        padding: 24px 16px;
        display: flex;
        justify-content: center;
        @media screen and (min-width: $above-tablet-length) {
            padding: 32px 16px
        }

        .sponsorship {
            display: flex;
            flex-direction: column;

            @media screen and (min-width: $above-tablet-length) {
                max-width: 400px;
            }

            .green-bloc {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                border-radius: 16px;
                overflow: hidden;
                background: linear-gradient(126deg, #2B6C5D 0%, #2C556A 100%);

                .left {
                    text-align: start;
                    padding: 30px 16px;
                    @media screen and (min-width: $above-tablet-length) {
                        padding: 30px 24px 30px 16px;
                    }

                    > p {
                        display: -webkit-box;
                        max-width: 200px;
                        -webkit-line-clamp: 4;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                    }
                }

                .users {
                    height: 100%;
                }
            }

            .white-bloc {
                padding: 24px 16px;
                background-color: $white;
                border-radius: 12px;
                margin-top: 16px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                text-align: start;
                overflow: hidden;
                position: relative;
                @media screen and (min-width: $above-tablet-length) {
                    padding: 16px;
                    margin-top: 24px;
                    border-radius: 16px;
                }

                .code-generating {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: space-between;
                }

                .copy-img {
                    position: absolute;
                    right: 16px;
                }

                .forest {
                    margin-top: 10px;
                    width: 100%;
                    margin-bottom: -16px;
                }

                .grey-bloc {
                    padding: 16px;
                    display: flex;
                    flex-direction: column;
                    background-color: $timberwolf;
                    border-radius: 16px;
                    overflow: hidden;

                    .referral {
                        display: flex;
                        flex-direction: column;
                        text-align: start;
                    }
                }

                .sponsor {
                    @media screen and (min-width: $above-tablet-length) {
                        margin-top: 8px;
                    }
                }
            }

            .middle-bloc {
                padding-top: 12px;
                padding-bottom: 12px;
                cursor: pointer;
            }
        }
    }
}
</style>
